var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChatRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icChatRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627451   0 0 0 0 0.419607843   0 0 0 0 0.274509804  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.4827586,0 C22.7397285,0 28.9655172,5.02600914 28.9655172,11.691721 C28.9655172,18.3564836 22.7397285,23.3824928 14.4827586,23.3824928 C14.2115166,23.3824928 13.9455788,23.3678992 13.6787972,23.3540175 L13.6611966,23.3531869 L6.63301352,27.9282185 C6.56020009,27.975796 6.47593423,28 6.39166836,28 C6.32054267,28 6.24857311,27.9826775 6.18371612,27.9481512 C6.04146473,27.872929 5.95285899,27.7261625 5.95285899,27.568006 L5.95285899,21.4137817 C2.11086596,19.4475622 -5.32907052e-15,16.0050171 -5.32907052e-15,11.691721 C-5.32907052e-15,5.02600914 6.22578878,0 14.4827586,0 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium+-upgrade",
    transform: "translate(-9.000000, -215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icChatRed",
    transform: "translate(15.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(11.000000, 11.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(11.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy-2",
    fill: "#F76B46",
    transform: "translate(14.482759, 14.000000) scale(-1, 1) translate(-14.482759, -14.000000) ",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("text", {
    id: 25,
    mask: "url(#mask-4)",
    fontFamily: "Muli-ExtraBold, Muli",
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: -0.7,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.5,
    y: 17
  }, "25"))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatRed);
export default __webpack_public_path__ + "static/media/icChatRed.a9b0a55d4f96bf2c17b32cfa56bd0c61.svg";
export { ForwardRef as ReactComponent };